import { Check } from "lucide-react";

export const TAGLINE = "Connected work. A brighter tomorrow.";

export const KlysticLogo = ({ className = "", symbolClass = "h-9", wordmarkClass = "h-4", label, testId = "klystic-logo" }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid={testId}>
    <img src="/assets/klystic-symbol.png" alt="" className={`${symbolClass} w-auto`} />
    <img src="/assets/klystic-wordmark.png" alt="Klystic" className={`${wordmarkClass} w-auto`} />
    {label && (
      <span className="ml-1 hidden sm:inline text-[11px] uppercase tracking-[0.24em] text-slate-600 font-mono">
        {label}
      </span>
    )}
  </div>
);

export const AuthHero = ({ overline, title, highlight, description, children }) => (
  <div className="hidden lg:flex lg:col-span-2 relative klystic-hero-bg p-12 overflow-hidden" data-testid="auth-hero">
    <div className="absolute top-0 left-0 w-full h-1 klystic-gradient" />
    <div className="relative z-10 flex flex-col justify-between h-full w-full">
      <div>
        <img
          src="/assets/klystic-logo.png"
          alt={`Klystic — ${TAGLINE}`}
          className="w-full max-w-[280px] h-auto klystic-fade-in"
          data-testid="auth-hero-logo"
        />
        <div className="overline mt-14 text-klystic-sky">{overline}</div>
        <h1 className="mt-4 font-heading text-4xl xl:text-5xl font-bold tracking-tight leading-[1.05] text-klystic-ink">
          {title}
          <br />
          <span className="klystic-underline">{highlight}</span>
        </h1>
        <p className="mt-6 text-slate-600 text-sm leading-relaxed max-w-md">{description}</p>
      </div>
      <div className="text-sm text-slate-600">{children}</div>
    </div>
  </div>
);

export const StepDot = ({ n, active, done, children }) => (
  <li className="flex items-center gap-3">
    <span
      className={`w-6 h-6 flex items-center justify-center text-xs font-bold border transition-colors ${
        done
          ? "bg-klystic-sky border-klystic-sky text-white"
          : active
          ? "bg-klystic-green border-klystic-green text-klystic-ink"
          : "bg-transparent border-slate-300 text-slate-500"
      }`}
    >
      {done ? <Check size={12} /> : n}
    </span>
    <span className={active || done ? "text-klystic-ink" : "text-slate-500"}>{children}</span>
  </li>
);
